<div class="table-time" [class.popover-open]="showFilterPopover">

    <div [ngSwitch]="tableType">
        <ng-container *ngSwitchCase="'radiotable'">
            <div #tableRoot class="radio-table-wrapper bank-details-table">
                <ng-container *ngIf="load ; else  realRadioTable">
                    <app-shimmer-loader type="tableShimmer" [pagination]="true">
                    </app-shimmer-loader>
                </ng-container>
                <ng-template #realRadioTable>
                    <div class="table-header">
                        <div class="filter-trigger" (click)="togglePopover($event)">
                            <p class="textHover" style="display: flex;">
                                <span class="filter-text">Filters</span>
                                <span>
                                    <mat-icon #filterTrigger class="filter-icon">filter_alt</mat-icon>
                                </span>
                            </p>
                            <app-filter-popover class="filter-popover" *ngIf="showFilterPopover"
                                [options]="statusOptions" [selected]="selectedStatuses" [isFull]="isSmallScreen"
                                (apply)="selectedStatuses = $event; applyStatusFilter()" (reset)="resetStatusFilter()"
                                (cancel)="showFilterPopover=false" [ngClass]="{'popover-full': isSmallScreen}"
                                (click)="$event.stopPropagation()">
                            </app-filter-popover>
                        </div>
                        <div class="search-box">
                            <input type="text" class="search" placeholder="Search" [(ngModel)]="searchText"
                                (keyup)="searchPrediction($event)" (ngModelChange)="onFilterChange()"
                                (paste)="preventPaste($event)" (copy)="preventCopy($event)" (cut)="preventCut($event)"
                                (contextmenu)="preventContext($event)" (drop)="preventDrop($event)">
                            <mat-icon class="search-icon" *ngIf="searchText; else showSearchIcon"
                                (click)="clearText()">close</mat-icon>
                            <ng-template #showSearchIcon>
                                <mat-icon class="search-icon" (click)="search()">search</mat-icon>
                            </ng-template>
                        </div>
                        <button class="add-bank-btn" (click)="addBankAccount()">Add Bank Account</button>
                    </div>
                    <br>

                    <table mat-table [dataSource]="filteringData" matSort
                        class="mat-elevation-z8 table-container radio-table mat-table">

                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef class="heading"> </th>
                            <td mat-cell *matCellDef="let row; let rowIndex = index">
                                <mat-radio-button [checked]="rowIndex === selectedRadioIndex"
                                    (change)="onSelectRow(rowIndex)">
                                </mat-radio-button>
                            </td>
                        </ng-container>

                        <ng-container *ngFor="let heading of displayedColumns; let i = index" [matColumnDef]="heading">
                            <ng-container *ngIf="sortableFields.includes(heading); else nonSortableHeaderRadio">
                                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="heading" class="heading">
                                    {{ (heading === 'Details' || heading === 'Actions') ? '' : heading }}
                                </th>
                            </ng-container>
                            <ng-template #nonSortableHeaderRadio>
                                <th mat-header-cell *matHeaderCellDef class="heading">
                                    {{ (heading === 'Details' || heading === 'Actions') ? '' : (heading !== 'select' ?
                                    heading :
                                    '') }}
                                </th>
                            </ng-template>

                            <td mat-cell *matCellDef="let row; let rowIndex = index">
                                <ng-container *ngIf="heading === 'select'; else otherCells">
                                    <mat-radio-button [checked]="row[heading] === 'selected'"
                                        (change)="onSelectRow(rowIndex)">
                                    </mat-radio-button>
                                </ng-container>

                                <ng-template #otherCells>
                                    <ng-container *ngIf="heading === 'Status'; else normalCell">
                                        <div class="status-cell">
                                            <span class="status-badge" [class.active]="row[heading] === 'Active'"
                                                [class.inactive]="row[heading] === 'In-Active' || row[heading] === 'Inactive'">
                                                {{ row[heading] }}
                                            </span>
                                        </div>
                                    </ng-container>

                                    <ng-template #normalCell>
                                        <span [innerHTML]="processText(row[heading])"></span>
                                    </ng-template>
                                </ng-template>

                            </td>
                        </ng-container>
                        <ng-container matColumnDef="edit">
                            <th mat-header-cell *matHeaderCellDef class="heading"> </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-buttons">
                                    <button class="edit-btn" (click)="editRow(row,'editBankAccount')">
                                        <span class="btn-text">Edit</span>
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <!-- Delete Button -->
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef class="heading"> </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-icon class="delete-icon"
                                    (click)="deleteRow(row, 'deleteBankAccount')">delete</mat-icon>
                            </td>
                        </ng-container>

                        <!-- Empty state row -->
                        <ng-container matColumnDef="emptyState">
                            <td mat-footer-cell *matFooterCellDef [attr.colspan]="allColumns.length">
                                <div class="empty-state">
                                    <mat-icon>search_off</mat-icon>
                                    <!-- <p class="title">No data available</p> -->
                                    <p class="hint">
                                        {{ buildEmptyMessage() }}
                                    </p>
                                    <button *ngIf="hasActiveFilters()" class="clear-filters-btn"
                                        (click)="resetAllFilters()">Clear Filters</button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: allColumns; let rowIndex = index"></tr>
                        <tr mat-footer-row *matFooterRowDef="['emptyState']"
                            [class.hide-footer]="!shouldShowEmptyState()">
                        </tr>
                    </table>
                    <app-mat-paginator *ngIf="showPagination && !noPagination && hasData()" [currentPage]="currentPage"
                        [visiblePages]="visiblePages" [totalPages]="totalPages" [showEllipsis]="false"
                        (pageChange)="goToPage($event)">
                    </app-mat-paginator>
                </ng-template>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'teamMember'">
            <div #tableRoot class="radio-table-wrapper team-members-table">
                <ng-container *ngIf="load ; else  realteamMemberTable">
                    <app-shimmer-loader type="tableShimmer" [pagination]="true">
                    </app-shimmer-loader>
                </ng-container>
                <ng-template #realteamMemberTable>
                    <div class="heading-table">
                        <h5 *ngIf="tableInfo">{{tableInfo}}</h5>
                        <div class="table-header">
                            <div class="filter-trigger" (click)="togglePopover($event)">
                                <p class="textHover" style="display: flex;">
                                    <span class="filter-text">Filters</span>
                                    <span>
                                        <mat-icon #filterTrigger class="filter-icon">filter_alt</mat-icon>
                                    </span>
                                </p>
                                <app-filter-popover class="filter-popover" *ngIf="showFilterPopover"
                                    [options]="statusOptions" [selected]="selectedStatuses" [isFull]="isSmallScreen"
                                    (apply)="selectedStatuses = $event; applyStatusFilter()"
                                    (reset)="resetStatusFilter()" (cancel)="showFilterPopover=false"
                                    [ngClass]="{'popover-full': isSmallScreen}" (click)="$event.stopPropagation()">
                                </app-filter-popover>
                            </div>
                            <div class="search-box">
                                <input type="text" class="search" placeholder="Search" [(ngModel)]="searchText"
                                    (keyup)="searchPrediction($event)" (ngModelChange)="onFilterChange()"
                                    (paste)="preventPaste($event)" (copy)="preventCopy($event)"
                                    (cut)="preventCut($event)" (contextmenu)="preventContext($event)"
                                    (drop)="preventDrop($event)">
                                <mat-icon class="search-icon" *ngIf="searchText; else showSearchIcon"
                                    (click)="clearText()">close</mat-icon>
                                <ng-template #showSearchIcon>
                                    <mat-icon class="search-icon" (click)="search()">search</mat-icon>
                                </ng-template>
                            </div>
                            <button class="add-bank-btn" (click)="addTeamMember()">Add Team Member</button>
                        </div>

                    </div>
                    <br>

                    <table mat-table [dataSource]="filteringData" matSort
                        class="mat-elevation-z8 table-container radio-table mat-table">
                        <ng-container *ngFor="let heading of displayedColumns; let i = index" [matColumnDef]="heading">
                            <ng-container *ngIf="sortableFields.includes(heading); else nonSortableHeaderTeam">
                                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="heading" class="heading">
                                    {{ (heading === 'Details' || heading === 'Actions') ? '' : heading }}
                                </th>
                            </ng-container>

                            <ng-template #nonSortableHeaderTeam>
                                <th mat-header-cell *matHeaderCellDef class="heading">{{ (heading === 'Details' ||
                                    heading
                                    === 'Actions') ? '' : heading }}</th>
                            </ng-template>
                            <td mat-cell *matCellDef="let row" [ngSwitch]="heading">
                                <ng-container *ngSwitchDefault>
                                    {{ row[heading] }}
                                </ng-container>

                                <ng-container *ngSwitchCase="'Client Name'">
                                    <div class="items-list">
                                        <span *ngFor="let item of row[heading]?.split(',')"
                                            [ngClass]="item.trim().toLowerCase() === 'unassigned' ? 'item-unassigned' : 'item-chip'">
                                            {{ item.trim() }}
                                        </span>
                                    </div>
                                </ng-container>

                            </td>
                        </ng-container>
                        <ng-container matColumnDef="edit">
                            <th mat-header-cell *matHeaderCellDef class="heading"> </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-buttons">
                                    <button class="edit-btn" (click)="editRow(row,'editTeamMember')">
                                        <span class="btn-text">Manage Client</span>
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <!-- Delete Button -->
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef class="heading"> </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-icon class="delete-icon"
                                    (click)="deleteRow(row, 'deleteTeamMember')">delete</mat-icon>
                            </td>
                        </ng-container>

                        <!-- Empty state row -->
                        <ng-container matColumnDef="emptyState">
                            <td mat-footer-cell *matFooterCellDef [attr.colspan]="allColumns.length">
                                <div class="empty-state">
                                    <mat-icon>search_off</mat-icon>
                                    <!-- <p class="title">No data available</p> -->
                                    <p class="hint">
                                        {{ buildEmptyMessage() }}
                                    </p>
                                    <button *ngIf="hasActiveFilters()" class="clear-filters-btn"
                                        (click)="resetAllFilters()">Clear Filters</button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: allColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="['emptyState']"
                            [class.hide-footer]="!shouldShowEmptyState()">
                        </tr>
                    </table>
                    <app-mat-paginator *ngIf="showPagination && !noPagination && hasData()" [currentPage]="currentPage"
                        [visiblePages]="visiblePages" [totalPages]="totalPages" [showEllipsis]="false"
                        (pageChange)="goToPage($event)">
                    </app-mat-paginator>
                </ng-template>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'withoutHeading'">
            <div class="profile-summary-table">
                <!-- <h2 *ngIf="load">I'm loading</h2> -->
                <ng-container *ngIf="load ; else  realTable">
                    <app-shimmer-loader type="tableShimmer" [pagination]="true">
                    </app-shimmer-loader>
                </ng-container>
                <ng-template #realTable>
                    <table mat-table [dataSource]="tableData" class="mat-elevation-z8 table-container mat-table">

                        <!-- Define a single column for label-value pairs -->
                        <ng-container matColumnDef="label">
                            <td mat-cell *matCellDef="let row" class="label-column">{{ row[0] }}</td>
                        </ng-container>

                        <ng-container matColumnDef="value">
                            <td mat-cell *matCellDef="let row" class="value-column">{{ row[1] }}</td>
                        </ng-container>

                        <ng-container matColumnDef="emptyState">
                            <td mat-footer-cell *matFooterCellDef [attr.colspan]="allColumns.length">
                                <div class="empty-state">
                                    <mat-icon>search_off</mat-icon>
                                    <!-- <p class="title">No data available</p> -->
                                    <p class="hint">
                                        {{ buildEmptyMessage() }}
                                    </p>
                                    <button *ngIf="hasActiveFilters()" class="clear-filters-btn"
                                        (click)="resetAllFilters()">Clear Filters</button>
                                </div>
                            </td>
                        </ng-container>
                        <!-- No header row needed -->
                        <tr mat-row *matRowDef="let row; columns: ['label', 'value']"></tr>
                        <!-- <tr
                              mat-footer-row
                              *matFooterRowDef="['emptyState']"
                              [class.hide-footer]="(tableData?.length ?? 0) > 0">
                            </tr> -->
                        <tr mat-footer-row *matFooterRowDef="['emptyState']"
                            [class.hide-footer]="!shouldShowEmptyState()">
                        </tr>
                    </table>
                </ng-template>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'sorting'">
            <div #tableRoot class="sorting-table-wrapper">
                <ng-container *ngIf="load ; else  realSortTable">
                    <app-shimmer-loader type="tableShimmer" [pagination]="true">
                    </app-shimmer-loader>
                </ng-container>
                <ng-template #realSortTable>
                    <div class="table-header"
                        [ngClass]="{ 'd-flex justify-content-between align-items-center': tableInfo }">
                        <h5 *ngIf="tableInfo">{{ tableInfo }}</h5>

                        <div class="d-flex align-items-center" *ngIf="showFilter">
                            <div class="filter-trigger" (click)="togglePopover($event)" *ngIf="statusOptions.length">
                                <p class="textHover">
                                    <span class="filter-text">Filters</span>
                                    <span>
                                        <mat-icon #filterTrigger class="filter-icon">filter_alt</mat-icon>
                                    </span>
                                </p>
                                <app-filter-popover class="filter-popover sorting-filter-popover"
                                    *ngIf="showFilterPopover" [options]="statusOptions" [selected]="selectedStatuses"
                                    [isFull]="isSmallScreen" (apply)="selectedStatuses = $event; applyStatusFilter()"
                                    (reset)="resetStatusFilter()" (cancel)="showFilterPopover=false"
                                    [ngClass]="{'popover-full': isSmallScreen}" (click)="$event.stopPropagation()">
                                </app-filter-popover>
                            </div>

                            <div class="search-box ms-3">
                                <input type="text" class="search" placeholder="Search" [(ngModel)]="searchText"
                                    (keyup)="searchPrediction($event)" (ngModelChange)="onFilterChange()"
                                    (paste)="preventPaste($event)" (copy)="preventCopy($event)"
                                    (cut)="preventCut($event)" (contextmenu)="preventContext($event)"
                                    (drop)="preventDrop($event)" />
                                <mat-icon class="search-icon" (click)="searchText ? clearText() : search()">
                                    {{ searchText ? 'close' : 'search' }}
                                </mat-icon>
                            </div>
                        </div>
                    </div>

                    <table mat-table [dataSource]="filteringData" matSort
                        class="mat-elevation-z8 table-container mat-table">
                        <ng-container *ngFor="let heading of displayedColumns" [matColumnDef]="heading">
                            <ng-container *ngIf="sortableFields.includes(heading); else nonSortableHeader">
                                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="heading"
                                    class="sortable-header heading" [ngClass]="{'text-right': isRightAligned(heading), 'text-center': isCenterAligned(heading)}">
                                    {{ (heading === 'Details' || heading === 'Actions') ? '' : (heading !== 'editIcon'
                                    &&
                                    heading !== 'deleteIcon' ? heading : '') }}
                                </th>
                            </ng-container>

                            <ng-template #nonSortableHeader>
                                <th mat-header-cell *matHeaderCellDef class="heading"
                                    [ngClass]="{'text-right': isRightAligned(heading), 'text-center': isCenterAligned(heading)}">{{ (heading === 'Details' ||
                                    heading
                                    ===
                                    'Actions') ? '' : (heading !== 'editIcon' && heading !== 'deleteIcon' ?
                                    heading : '') }}
                                </th>
                            </ng-template>

                            <td mat-cell *matCellDef="let row; let rowIndex = index" [ngSwitch]="heading"
                                [ngClass]="{'text-right': isRightAligned(heading), 'text-center': isCenterAligned(heading)}"
                                (click)="logTdClick(heading, rowIndex, $event); onCellClick($event, row['_originalIndex'], getOriginalIndex(heading), row[heading])">
                                <ng-container *ngSwitchCase="'Team Members name'">
                                    <div class="items-list">
                                        <ng-container
                                            *ngFor="let item of row[heading]?.split(','); let chipIndex = index">
                                            <a *ngIf="getChipUrl(row, heading, chipIndex) as url" [href]="url"
                                                style="text-decoration: none; color: inherit;">
                                                <span
                                                    [ngClass]="item.trim().toLowerCase() === 'unassigned' ? 'item-unassigned' : 'item-chip'">
                                                    {{ item.trim() }}
                                                </span>
                                            </a>
                                            <span *ngIf="!getChipUrl(row, heading, chipIndex)"
                                                [ngClass]="item.trim().toLowerCase() === 'unassigned' ? 'item-unassigned' : 'item-chip'">
                                                {{ item.trim() }}
                                            </span>
                                        </ng-container>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'Status'">
                                    <div class="status-cell">
                                        <span class="status-badge" [class.active]="row[heading] === 'Active'"
                                            [class.inactive]="['In-Active', 'Inactive', 'In-active'].includes(row[heading])"
                                            [class.approved]="row[heading] === 'Approved'"
                                            [class.declined]="row[heading] === 'Declined'"
                                            [class.under-review]="row[heading] === 'Under Review'">
                                            {{ row[heading] }}
                                        </span>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'Query Status'">
                                    <div class="status-cell">
                                        <span class="status-badge" [class.open]="row[heading] === 'Open'"
                                            [class.in-progress]="row[heading] === 'In Progress'"
                                            [class.closed]="row[heading] === 'Closed'">
                                            {{ row[heading] }}
                                        </span>
                                    </div>
                                </ng-container>


                                <ng-container *ngSwitchCase="'Action'">
                                    <div class="action-buttons">
                                        <button class="approve-btn" (click)="approveRow(row)">
                                            Approve <mat-icon>check</mat-icon>
                                        </button>
                                        <button class="decline-btn" (click)="declineRow(row)">
                                            Decline <mat-icon>cancel</mat-icon>
                                        </button>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'editIcon'">
                                    <mat-icon (click)="editRow(row, 'editTaxAgent')">edit</mat-icon>
                                </ng-container>

                                <ng-container *ngSwitchCase="'deleteIcon'">
                                    <mat-icon class="delete-icon"
                                        (click)="deleteRow(row, 'deleteTaxAgent')">delete</mat-icon>
                                </ng-container>

                                <ng-container *ngSwitchDefault>
                                    <ng-container *ngIf="tableUrls; else defaultText">
                                        <ng-container
                                            *ngIf="getCellFragments(row['_originalIndex'], getOriginalIndex(heading), row[heading]) as fragments">
                                            <ng-container *ngIf="fragments.length > 0; else defaultText">
                                                <ng-container *ngFor="let fragment of fragments">
                                                    <a *ngIf="fragment.url" [href]="fragment.url"
                                                        (click)="onLinkClick($event, fragment.url)"
                                                        (mousedown)="onMouseDownNavigate($event, fragment.url)"
                                                        [target]="getLinkTarget(fragment.url)">
                                                        <span [innerHTML]="fragment.text"></span>
                                                    </a>
                                                    <span *ngIf="!fragment.url" [innerHTML]="fragment.text"></span>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #defaultText>
                                        <span [innerHTML]="processText(row[heading])"></span>
                                    </ng-template>
                                </ng-container>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="deleteAction" *ngIf="tableInfo === 'Client\'s List'">
                            <th mat-header-cell *matHeaderCellDef class="heading"></th>
                            <td mat-cell *matCellDef="let row">
                                <ng-container *ngIf="row['Status'] === 'Active'">
                                    <mat-icon (click)="deleteRow(row, 'deleteClientList')" class="delete-icon">
                                        delete
                                    </mat-icon>
                                </ng-container>
                            </td>
                        </ng-container>

                        <!-- Empty state row -->
                        <ng-container matColumnDef="emptyState">
                            <td mat-footer-cell *matFooterCellDef
                                [attr.colspan]="getDisplayedColumnsWithDelete().length">
                                <div class="empty-state">
                                    <mat-icon>search_off</mat-icon>
                                    <!-- <p class="title">No data available</p> -->
                                    <p class="hint">
                                        {{ buildEmptyMessage() }}
                                    </p>
                                    <button *ngIf="hasActiveFilters()" class="clear-filters-btn"
                                        (click)="resetAllFilters()">Clear Filters</button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="getDisplayedColumnsWithDelete()"></tr>
                        <tr mat-row *matRowDef="let row; columns: getDisplayedColumnsWithDelete();"></tr>
                        <tr mat-footer-row *matFooterRowDef="['emptyState']"
                            [class.hide-footer]="!shouldShowEmptyState()">
                        </tr>
                    </table>

                    <app-mat-paginator *ngIf="showPagination && !noPagination && hasData()" [currentPage]="currentPage"
                        [visiblePages]="visiblePages" [totalPages]="totalPages" [showEllipsis]="false"
                        (pageChange)="goToPage($event)"></app-mat-paginator>
                </ng-template>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'info-table'">
            <h5 *ngIf="tableInfo">{{ tableInfo }}</h5>
            <ng-container *ngIf="load ; else  realInfoTable">
                <app-shimmer-loader type="tableShimmer" [pagination]="true">
                </app-shimmer-loader>
            </ng-container>
            <ng-template #realInfoTable>
                <table mat-table [dataSource]="filteringData" class="mat-elevation-z8 table-container mat-table">
                    <ng-container *ngFor="let heading of displayedColumns; let i = index" [matColumnDef]="heading">
                        <th class="heading" mat-header-cell *matHeaderCellDef>
                            <div class="header-cell">
                                {{ (heading === 'Details' || heading === 'Actions') ? '' : heading }}

                                <ng-container
                                    *ngIf="heading === 'Level 1' || heading === 'Level 2' || heading === 'Level 3'">
                                    <!-- Info popup removed; show tooltip instead -->
                                    <mat-icon class="info-icon" matTooltip="No info available right now">info</mat-icon>
                                </ng-container>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let row; let rowIndex = index">
                            <span [innerHTML]="processText(row[heading])"></span>
                        </td>
                    </ng-container>

                    <!-- Empty state row -->
                    <ng-container matColumnDef="emptyState">
                        <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
                            <div class="empty-state">
                                <mat-icon>search_off</mat-icon>
                                <p class="hint">
                                    {{ buildEmptyMessage() }}
                                </p>
                                <button *ngIf="hasActiveFilters()" class="clear-filters-btn"
                                    (click)="resetAllFilters()">Clear Filters</button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    <tr mat-footer-row *matFooterRowDef="['emptyState']" [class.hide-footer]="!shouldShowEmptyState()">
                    </tr>
                </table>
                <app-mat-paginator *ngIf="showPagination && !noPagination && hasData()" [currentPage]="currentPage"
                    [visiblePages]="visiblePages" [totalPages]="totalPages" [showEllipsis]="false"
                    (pageChange)="goToPage($event)">
                </app-mat-paginator>
            </ng-template>
        </ng-container>

        <ng-container *ngSwitchCase="'radioInfoTable'">
            <div class="radio-info-table">
                <ng-container *ngIf="load ; else realRadioInfoTable">
                    <app-shimmer-loader type="tableShimmer" [pagination]="true"></app-shimmer-loader>
                </ng-container>
                <ng-template #realRadioInfoTable>
                    <mat-radio-group [(ngModel)]="selectedValue" (ngModelChange)="selectedValueChange.emit($event)"
                        [ngModelOptions]="{standalone: true}">
                        <table mat-table [dataSource]="filteringData"
                            class="mat-elevation-z8 table-container mat-table">
                            <ng-container *ngFor="let column of displayedColumns; let i = index"
                                [matColumnDef]="column">
                                <th class="heading" *matHeaderCellDef>
                                    <div class="header-content"
                                        [class.level-header]="(infoColumns || responseData?.tableHeadings)?.includes((responseData?.tableHeadings?.[i]) || column)">
                                        <div class="header-left">
                                            <mat-radio-button
                                                *ngIf="(infoColumns || responseData?.tableHeadings)?.includes((responseData?.tableHeadings?.[i]) || column)"
                                                [value]="responseData?.tableHeadings?.[i] || column">
                                            </mat-radio-button>
                                            <span>{{ responseData?.tableHeadings?.[i] || column }}</span>
                                        </div>
                                        <mat-icon
                                            *ngIf="(infoColumns || responseData?.tableHeadings)?.includes((responseData?.tableHeadings?.[i]) || column)"
                                            class="info-icon" matTooltip="No info available right now">info</mat-icon>
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                            </ng-container>

                            <ng-container matColumnDef="emptyState">
                                <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
                                    <div class="empty-state">
                                        <mat-icon>search_off</mat-icon>
                                        <p class="hint">
                                            {{ buildEmptyMessage() }}
                                        </p>
                                        <button *ngIf="hasActiveFilters()" class="clear-filters-btn"
                                            (click)="resetAllFilters()">Clear
                                            Filters</button>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </mat-radio-group>
                    <app-mat-paginator *ngIf="showPagination && !noPagination && hasData()" [currentPage]="currentPage"
                        [visiblePages]="visiblePages" [totalPages]="totalPages" [showEllipsis]="false"
                        (pageChange)="goToPage($event)">
                    </app-mat-paginator>
                </ng-template>
            </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <h5 *ngIf="tableInfo">{{tableInfo}}</h5>

            <div #tableRoot class="table-time">
                <ng-container *ngIf="load ; else  realTimeTable">
                    <app-shimmer-loader type="tableShimmer" [pagination]="true">
                    </app-shimmer-loader>
                </ng-container>
                <ng-template #realTimeTable>
                    <table mat-table [dataSource]="filteringData" class="mat-elevation-z8 table-container mat-table">

                        <ng-container *ngFor="let heading of internalColumns; let i = index" [matColumnDef]="heading">

                            @if(isParagraphWithList && internalColumns[i] === differentForColomn) {

                            <th class="heading" mat-header-cell *matHeaderCellDef>
                                <!-- Only show header text if headings exist -->
                                <ng-container *ngIf="!noHeaders">{{ (heading === 'Details' || heading === 'Actions') ?
                                    '' :
                                    heading }}</ng-container>
                            </th>

                            <td mat-cell *matCellDef="let row; let rowIndex = index" class="paragraph-with-list-cell">
                                <span class="paragraph-with-list-text" [innerHTML]="processText(row[heading])"></span>
                                <app-list-with-tag class="paragraph-with-list-items" [cssClass]="'font-css'"
                                    [listTag]="listTag" [listItems]="listItems?.[rowIndex]">
                                </app-list-with-tag>
                            </td>

                            } @else if (isRowWithSpans && internalColumns[i] === differentForColomn) {

                            <th class="heading" mat-header-cell *matHeaderCellDef>
                                <ng-container *ngIf="!noHeaders">{{ heading }}</ng-container>
                            </th>

                            <td mat-cell *matCellDef="let row; let rowIndex= index;" [attr.rowspan]="rowSpans[rowIndex]"
                                [style.display]="rowSpans[rowIndex] === 0 ? 'none' : ''">
                                <span [innerHTML]="processText(row[heading])"></span>
                            </td>

                            } @else {

                            <th class="heading" mat-header-cell *matHeaderCellDef>
                                <ng-container *ngIf="!noHeaders">{{ heading }}</ng-container>
                            </th>

                            <td mat-cell *matCellDef="let row; let rowIndex = index"
                                [attr.colspan]="isColWithSpans ? getColSpan(rowIndex, i) : null"
                                [style.display]="isColWithSpans && shouldHideCell(rowIndex, i) ? 'none' : ''">
                                <ng-container *ngIf="hasLinks && tableUrls; else defaultCell">
                                    <ng-container
                                        *ngIf="getCellFragments(rowIndex, getOriginalIndex(heading), row[heading]) as fragments; else defaultCell">
                                        <ng-container *ngIf="fragments.length; else defaultCell">
                                            <ng-container *ngFor="let fragment of fragments">
                                                <ng-container *ngIf="fragment.url; else textFragment">
                                                    <a [href]="fragment.url" [target]="getLinkTarget(fragment.url)"
                                                        (click)="onCellLinkClick(fragment.url, $event)"
                                                        (mousedown)="onCellLinkMouseDown(fragment.url, $event)">
                                                        <ng-container
                                                            *ngFor="let part of getLinkSegments(fragment.text)">
                                                            <ng-container *ngIf="part.isWhitespace; else wordPart">
                                                                <span class="link-space">{{ part.text }}</span>
                                                            </ng-container>
                                                            <ng-template #wordPart>
                                                                <span class="link-word">{{ part.text }}</span>
                                                            </ng-template>
                                                        </ng-container>
                                                    </a>
                                                </ng-container>
                                                <ng-template #textFragment>
                                                    <span *ngIf="fragment.isHtml; else plainText"
                                                        [innerHTML]="fragment.text"></span>
                                                    <ng-template #plainText>{{ fragment.text }}</ng-template>
                                                </ng-template>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <ng-template #defaultCell>
                                    <ng-container
                                        *ngIf="isMultipleParagraphs && row[heading]?.includes && row[heading].includes('\n'); else singlePara">
                                        <div *ngFor="let para of row[heading].split('\n')" style="margin-bottom: 8px;">
                                            {{ para }}
                                        </div>
                                    </ng-container>
                                    <ng-template #singlePara>
                                        <span [innerHTML]="processText(row[heading])"></span>
                                    </ng-template>
                                </ng-template>
                            </td>

                            }

                        </ng-container>

                        <!-- Header row: render ONLY if headings exist -->
                        <tr mat-header-row *matHeaderRowDef="internalColumns" [style.display]="noHeaders ? 'none' : ''">
                        </tr>

                        <tr mat-row *matRowDef="let row; columns: internalColumns; let rowIndex = index"
                            [class.nested-sub-row]="isNestedSubRow(rowIndex)"
                            [class.last-nested-sub-row]="isLastNestedSubRow(rowIndex)">
                        </tr>
                    </table>
                    <app-mat-paginator *ngIf="showPagination && !noPagination && hasData()" [currentPage]="currentPage"
                        [visiblePages]="visiblePages" [totalPages]="totalPages" [showEllipsis]="false"
                        (pageChange)="goToPage($event)">
                    </app-mat-paginator>
                </ng-template>
            </div>

        </ng-container>
    </div>
</div>